<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'BasePageTitleSubtitle',
  mixins: [baseMixin],
  props: {
    subtitleClass: {
      type: String,
      default: 'text-subtitle-2 mb-0',
    },
  },
}
</script>

<template>
  <h4 :class="[!isMobileViewPort ? subtitleClass : 'body-2']"><slot></slot></h4>
</template>
